import {Button, Layout} from "antd";
import {setCurrentUser} from "../../store/CommonSlice";
import {getAuth, setAuth} from "../../store/AuthSlice";
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import {ApiContext} from "../../ApiContext";
import {useContext} from "react";
import {useNavigate} from "react-router-dom";


import './HomePage.css'

const HomePage = () => {
    const {saveToStore, txt, clearAllStates} = useContext(ApiContext);
    const auth = useSelector(getAuth);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const doLogout = () => {
        const body = {access_token: auth.accessToken, refresh_token: auth.refreshToken}
        axios.post('/user/logout', body)
            .catch(error => {
            })
            .finally(() => {
                dispatch(setAuth({accessToken: '', refreshToken: ''}));
                dispatch(setCurrentUser({uuid: ''}));

                saveToStore('access_token', '');
                saveToStore('refresh_token', '');

                // clearAllStates();
                // переход на логин произойдет из-за useEffect в BananaAppbar
            });
    };
    return (
        <Layout.Content>
            <Button danger onClick={() => {
                navigate('/delete-account')
            }}>
                {txt("clientSettingsView.deleteAccountButtonLabel")}
            </Button>
            <Button type="primary" onClick={() => {
                navigate('/settings')
            }}>
                {txt("clientSettingsView.appbarSettings")}

            </Button>
            <Button type="primary" onClick={doLogout}>
                {txt("appBarMenu.logout")}
            </Button>
        </Layout.Content>
    );
}

export default HomePage;